import React from 'react';
import {useIntl} from 'react-intl';
import Modal from '@ignitesales/react-modal';
import ConnectedShareViaEmail from '@ignitesales/social-share-email/src/ConnectedShareViaEmail';
import classnames from 'classnames';
import {notifySuccess} from "../Notifications";
import {useAppContext} from "../../AppContext";

const ShareViaEmailModal = ({ active, onClose, className }) => {
  const intl = useIntl();
  const appContext = useAppContext();
  const classes = classnames(
    className,
    'shareViaEmail'
  );

  const onEmailSent = () => {
    notifySuccess('shareViaEmail.submitted');
    onClose();
  };

  return <Modal
    show={ active }
    className={classes}
    title={ intl.formatMessage({ id: 'shareViaEmail.title' }) }
    onClose={ onClose }
    nodeId="root"
    closeBtn={appContext.modalCloseBtn}
  >
    <ConnectedShareViaEmail
      onSubmit={ onEmailSent }
      hasBeenClicked={ active }
    />
  </Modal>;
};

export default ShareViaEmailModal;
